import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AdminHeader from "../../components/admin/AdminHeader";
import { useAuth } from "../../context/AuthContext";

export const RequireAuth = ({ children }) => {
  const { loading, checked, isAuthenticated, refresh } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!checked && !loading) refresh();
  }, [checked, loading, refresh]);

  if (!checked || loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background" data-testid="admin-loading">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  return children;
};

/** Admin shell: one header with labelled links to every area, then the page content. */
const AdminLayout = () => (
  <div className="min-h-screen bg-background text-foreground" data-testid="admin-layout">
    <AdminHeader />
    <main className="mx-auto w-full max-w-[1600px] px-5 py-6 lg:px-8 lg:py-8">
      <Outlet />
    </main>
  </div>
);

export default AdminLayout;
